import * as React from 'react';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import IconExpand from '../../icons/icon-disclose';
import FormItem from '../__partials/form-item';
import HelpText from '../__partials/help-text';
import Label from '../__partials/label';
import useFieldId from '../__partials/use-field-id';

type IProps = {
  label?: string;
  status?: 'default' | 'error' | 'success';
  statusText?: string;
  helpText?: any;
  isDisabled?: boolean;
  className?: string;
  children: any;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const Select = ({
  id,
  name,
  label,
  status = 'default',
  statusText,
  helpText,
  isDisabled,
  className,
  children,
  ...props
}: IProps): ReactElement => {
  const selectId = useFieldId(id, name);

  const selectClasses = twMerge(
    'relative h-11 w-full appearance-none rounded-sm border-2 border-solid border-form-input-border px-4 py-0',
    'bg-neutral-white text-base font-medium tracking-[0.02em] text-type-black font-[inherit]',
    'outline-0 focus:border-form-input-active active:border-form-input-active',
    className
  );

  return (
    <FormItem status={status} isDisabled={isDisabled}>
      <div className="relative [&>svg]:pointer-events-none [&>svg]:absolute [&>svg]:right-3.5 [&>svg]:bottom-4.5">
        {label && <Label label={label} statusText={statusText} id={selectId} />}
        <select
          {...props}
          className={selectClasses}
          id={selectId}
          name={name}
          disabled={isDisabled}
          aria-disabled={isDisabled}>
          {children}
        </select>
        <IconExpand />
      </div>
      {helpText && <HelpText text={helpText} />}
    </FormItem>
  );
};

export default Select;
